// import firebase from 'firebase/app';
// import 'firebase/auth';

// const firebaseConfig = {
//     apiKey: 'AIzaSyCyf9nzoyrI1ARbv5YsdU83slkUsbX6_CA',
//     authDomain: 'otp-code-e2c5a.firebaseapp.com',
//     projectId: 'otp-code-e2c5a',
//     storageBucket: 'otp-code-e2c5a.appspot.com',
//     messagingSenderId: '577856734512',
//     appId: '1:577856734512:web:b195fee89539ec2b4c34f5',
//     measurementId: 'G-N5YHG43SR2'
// };
// // Initialize Firebase
// if (!firebase.apps.length) {
//     firebase.initializeApp(firebaseConfig);
// }

// export default firebase;


import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';

const firebaseConfig = {
    apiKey: 'AIzaSyDG_2VJkRulAVHHY3hngVvbMX10dwgnv6M',
    authDomain: 'billion-girl-sms-otp.firebaseapp.com',
    projectId: 'billion-girl-sms-otp',
    storageBucket: 'billion-girl-sms-otp.firebasestorage.app',
    messagingSenderId: '1083294411542',
    appId: '1:1083294411542:web:da7b851b662768a71f7e37',
    measurementId: 'G-GT3BZDE2Z2'
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase Authentication and get a reference to the service
export const auth = getAuth(app);